<template>
  <div>
    <a-card>
      <BaseTable ref="baseTable"
                 @searchReset="searchReset"
                 @selectRow="selectRow"
                 :mainTable="mainTable"
                 :tableColumns="columns"
                 :tableData="tableData">
        <template #leftButton>
          <mtc-button @click="add" type="primary" icon="plus" text="新建" />
          <mtc-button @click="addEnhanceJs" type="primary" icon="database" text="JS增强" style="margin-left: 10px" />
        </template>
        <template #action="{ record }">
          <a @click="handleEdit(record)">{{ $t('button.edit') }}</a>
          <a-divider type="vertical" />
          <a-popconfirm @confirm="() => handleDeleteOne(record)">
            <mtcLangPopover slot="title" text="tip.isDelete" />
            <mtcLangPopover text="button.delete">
              <a>{{ $t('button.delete') }}</a>
            </mtcLangPopover>
          </a-popconfirm>
        </template>
      </BaseTable>
    </a-card>
    <!-- 新增模态框 -->
    <j-modal :visible="visible"
             width="40%"
             :title="modalTitle"
             @ok="saveForm"
             @cancel="cancelModal">
      <a-form-model ref="addForm" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules">
        <a-form-model-item label="编码" prop="code">
          <a-input v-model="form.code" placeholder="请输入编码" />
        </a-form-model-item>
        <a-form-model-item label="JS增强">
          <a-textarea v-model="form.enjs" :auto-size="{ minRows: 5, maxRows: 20 }" placeholder="JS增强方法" style="margin-top: 10px" />
        </a-form-model-item>
      </a-form-model>
    </j-modal>
    <!-- JS增强编辑器 -->
    <EnhanceJs ref="EnhanceJs" :key="jsKey" :JSText="form.enjs" @handleSubmit="handleSubmit" />
  </div>
</template>

<script>
import EnhanceJs from '@views/modules/online/cgform/modules/EnhanceJs'
import { BaseTable } from '@comp/mtcModule'
import { enhanceJSAdd, enhanceJSDelete, enhanceJSEdit, enhanceJSList } from '@api/online'

export default {
  name: 'UtilEnhanceJs',
  title: '通用JS增强方法',
  components: { BaseTable, EnhanceJs },
  data() {
    return {
      modalTitle: '新增',
      // 在线编辑器组件key
      jsKey: '',
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      form: {
        code: '',
        enjs: ''
      },
      mainTable: '',
      queryParams: {
        code: '',
        enjs: ''
      },
      columns: [
        {
          width: 150,
          align: 'center',
          title: '编码',
          dataIndex: 'code'
        },
        {
          align: 'center',
          title: 'JS',
          dataIndex: 'enjs',
          ellipsis: true
        },
        {
          width: 150,
          align: 'center',
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      tableData: params => this.getTableData(params),
      visible: false,
      rules: {
        code: [{ required: true, message: '请输入编码', trigger: 'change' }]
      },
      // 列表选中当前行数据
      selectedRow: []
    }
  },
  methods: {
    // 获取列表数据
    getTableData(baseParams) {
      let params = {
        ...baseParams,
        ...this.queryParams
      }
      return enhanceJSList(params)
    },
    searchReset() {
      this.$refs.baseTable.refresh()
    },
    selectRow(ids, rows) {
      this.selectedRow = rows
    },
    // 新增
    add() {
      this.modalTitle = '新增'
      this.openModal()
    },
    // 编辑
    handleEdit(row) {
      this.openModal()
      this.form = row
      this.modalTitle = '编辑'
    },
    // 删除
    handleDeleteOne({ id }) {
      if (!id) return
      enhanceJSDelete({ id }).then(res => {
        this.$message.success('操作成功')
        this.searchReset()
      })
    },
    // 打开在线编辑器
    addEnhanceJs() {
      if (this.selectedRow.length !== 1) return this.$message.warning('请选择一条数据')
      this.form = this.selectedRow[ 0 ]
      this.jsKey++
      this.$nextTick(() => {
        this.$refs.EnhanceJs.show({ id: '-1' })
      })
    },
    // 在线编辑JS提交
    handleSubmit(jsText) {
      this.form.enjs = jsText
      this.editFormSave()
    },
    // 打开新增编辑模态框
    openModal() {
      this.visible = true
      this.form = {}
    },
    // 关闭新增编辑模态框
    cancelModal() {
      this.visible = false
    },
    // 新建保存
    saveForm() {
      this.verifyForm(() => {
        if(this.modalTitle === '编辑') return this.editFormSave()
        enhanceJSAdd(this.form).then(res => {
          this.$message.success('操作成功')
          this.cancelModal()
          this.searchReset()
        })
      })
    },
    // 编辑保存
    editFormSave() {
      enhanceJSEdit(this.form).then(res => {
        this.$message.success('操作成功')
        this.cancelModal()
        this.searchReset()
      })
    },
    // 表单校验
    verifyForm(callback) {
      this.$refs.addForm.validate(valid => {
        if (!valid) return false
        callback()
      })
    }
  }
}
</script>